import client from './client';

export default (function RoundPnmsService() {
  let service;

  if (!service) {
    service = client.service('roundPnms');
  }

  return service;
}());
